import { useGetOrgTypes } from '@/service-library/hooks/org-types'
import { Organization } from '@/types/organizations'
import { getOrganizationType } from '@/utils/organization'

type UseOrganizationTypeNameOptions = {
  organization?: Organization
}

export default function useOrganizationTypeName({
  organization,
}: UseOrganizationTypeNameOptions) {
  const { orgTypes } = useGetOrgTypes({
    filters: {
      limit: '1000',
    },
    enabled: !!organization,
  })
  return organization
    ? getOrganizationType(organization, orgTypes)?.name || 'Organization'
    : 'Organization'
}
